import React from 'react';
import { Tag } from '../../services/tagService';
import './TagDisplay.css';

interface TagDisplayProps {
  tags: string[];
  availableTags?: Tag[];
  onRemove?: (tagName: string) => void;
}

const TagDisplay: React.FC<TagDisplayProps> = ({ tags, availableTags = [], onRemove }) => {
  // Get tag color from availableTags if provided
  const getTagColor = (tagName: string): string => {
    const tag = availableTags.find(t => t.name === tagName);
    return tag?.color_code || '#666666'; // Default gray color
  };

  if (tags.length === 0) {
    return null;
  }

  return (
    <div className="tag-display-container">
      {tags.map((tagName) => (
        <span
          key={tagName}
          className="tag-chip"
          style={{ backgroundColor: getTagColor(tagName) }}
        >
          <span className="tag-chip-name">{tagName}</span>
          {onRemove && (
            <button
              className="tag-chip-remove"
              onClick={(e) => {
                e.stopPropagation();
                onRemove(tagName);
              }}
              title="Remove tag"
            >
              ×
            </button>
          )}
        </span>
      ))}
    </div>
  );
};

export default TagDisplay;

